import { Card, CardBody } from "@/components/common";
import { useAuth } from "@/auth/useAuth";
import { MfaSetupFlow } from "./MfaSetupFlow";
import "@/components/auth/LoginPage.css";
import "./Mfa.css";

/**
 * Mandatory MFA enrollment screen for platform admins (mirrors the backend
 * MFA_SETUP_REQUIRED 403). Renders the same enrollment flow as the settings
 * page, but blocks the whole app shell until MFA is active.
 */
export function MfaSetupRequired() {
  const { refresh } = useAuth();

  return (
    <div className="mfa-shell">
      <div className="mfa-shell-inner">
        <header className="mfa-shell-head">
          <h1 className="login-title">Ative a autenticação em dois fatores</h1>
          <p className="login-sub" style={{ margin: 0 }}>
            Administradores da plataforma precisam configurar o segundo fator antes de continuar.
          </p>
        </header>

        <Card>
          <CardBody>
            <MfaSetupFlow onActivated={refresh} />
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
